import { send_z3k_custom_command } from 'console/redux/z3k-custom-command/actions';
import { WebElement } from 'z3k-config';
import { setZ3kAnalogOutputValue } from 'console/redux/z3k-analog-output-value/action';
import { fixObjectName } from 'z3k-settings/utils/fix-object-name';
function getSliderCustomCommand(device_id, object_id) {
    return (new_value) => {
        console.log('getSliderCustomCommand', new_value, object_id);
        return setZ3kAnalogOutputValue(device_id, object_id, new_value || 0);
    };
}
function getDifficultButtonCustomCommand(device_id, object_id) {
    return (state) => send_z3k_custom_command(device_id, {
        command_name: 'ChangeWebElementState',
        object_id,
        command_args: { state: state ?? 0 },
    });
}
function getButtonCustomCommand(device_id, object_id) {
    return () => send_z3k_custom_command(device_id, {
        command_name: 'ChangeWebElementState',
        object_id,
        command_args: { state: 1 },
    });
}
export function getZ3KCustomControlsConfig(device_id, z3k_config, show_hidden_elements) {
    const custom_controls = WebElement.get.where(z3k_config, (web_element) => !WebElement.isCardHidden(web_element) || show_hidden_elements);
    const shared_custom_controls = custom_controls.map((custom_control) => {
        const { id, label1, label2, type, name, id_active } = custom_control;
        const labels = {
            active_label: label1,
            inactive_label: label2,
        };
        const is_label_hidden = WebElement.isLabelHidden(custom_control);
        const is_inverted = WebElement.isInverted(custom_control);
        if (type === WebElement.Type.STATUS) {
            return {
                id,
                name: fixObjectName(name),
                labels,
                type,
                is_label_hidden,
                is_inverted,
            };
        }
        if (type === WebElement.Type.SIMPLE) {
            return {
                id,
                name: fixObjectName(name),
                labels,
                type,
                sendCustomCommand: getButtonCustomCommand(device_id, id),
                is_label_hidden,
            };
        }
        if (type === WebElement.Type.ANALOG) {
            return {
                id,
                name: fixObjectName(name),
                type,
                sendCustomCommand: getSliderCustomCommand(device_id, id),
                id_active,
                is_label_hidden,
            };
        }
        return {
            id,
            name: fixObjectName(name),
            labels,
            type,
            sendCustomCommand: getDifficultButtonCustomCommand(device_id, id),
            is_label_hidden,
        };
    });
    return shared_custom_controls;
}
